import { Component } from '@angular/core';
import { TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../core/i18n';

/**
 * Public confirmation shown when local logout completed but Okta federated sign-out did not redirect (OM-720).
 */
@Component({
  selector: 'app-signed-out',
  imports: [TranslatePipe, TypographyComponent],
  templateUrl: './signed-out.html',
  styleUrl: './signed-out.scss',
})
export class SignedOut {
  /** Absolute URL for the approved post-logout destination registered with Okta. */
  protected readonly purolatorHomeUrl = 'https://www.purolator.com';
}
